export const IsProduction = process.env.NODE_ENV === 'production'

// localstorage
export const Authorization = 'Authorization'
export const AuthTimeout = 'AuthTimeout'
export const UserInfo = 'UserInfo'
export const Account = 'Account'

// http
export const URL = '/site'

// export const URL = 'https://api-test.kolacdn.xyz/site'
export const OK = 'ok'
export const Fail = 'fail'

export const RouterPaths = {
  home: '/payment',
  "signin-email": '/payment/signin-email',
  "forget-email": '/payment/forget-email',
  "signin-phone": "/payment/signin-phone",
  "forget-phone": '/payment/forget-phone',
  "reset-password": "/payment/reset-password",
  "signin-qr": "/payment/signin-qr",

  menu: '/payment/menu',
  records: '/payment/menu/recharge-record',
  userInfo: '/payment/menu/user-info',
  settings: '/payment/menu/settings',
  CDKey:'/payment/menu/CDKey',
  equipment:'/payment/menu/equipment',
  camilo:'/payment/menu/camilo',
  delAccount:'/payment/menu/delAccount',
  router:'/payment/menu/router',

  myAffiliate: '/payment/affiliate',
  affiliateWithdrawRecords: '/payment/affiliate/withdraw-records',
  affiliateAwardRecords: '/payment/affiliate/award-records',
  thanksForUsing:'/payment/thanks-for-using',
  Activity:'/payment/activity',
  ActivityLite:'/payment/activity_lite',
  shop:'/payment/shop',
}
